import { Redirect, Prompt, useHistory } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import I18n from 'I18n';
import TrackExamPage from '../../components/TrackPage/TrackExamPage';
import { TRACK_COMPLETE_URL_FRAGMENT, TRACKS_URL_FRAGMENT } from '../../constants/Navigation';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../constants/Tracking';
import { DateFormats } from '../../constants/CourseConstants';
// @ts-expect-error Could not find a declaration file for module
import TrackDeprecatedModal from '../../components/Modals/FeatureIntroModals/TrackDeprecatedModal';
import { isTrackDeprecated } from '../../utils/utils';
import { useCallback, useEffect, useState } from 'react';
import { getExamDeadline, getMostRecentExamAttempt } from '../../features/exams/examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackExamPageContainer = ({
  track,
  trackProgress
}) => {
  const {
    id: trackId,
    exam,
    name,
    hsSoftwareFilters,
    subCategories,
    deprecated,
    deprecationFinalDate,
    deprecationCta,
    deprecationMessage
  } = track;
  const [pageViewTracked, setPageViewTracked] = useState(false);
  const history = useHistory();
  const mostRecentExamAttempt = exam && getMostRecentExamAttempt(exam.id, trackProgress);
  const isExamAttemptInProgress = mostRecentExamAttempt ? !mostRecentExamAttempt.attemptFinishTime : false;
  const examDeadline = getExamDeadline(exam, mostRecentExamAttempt);
  const handleNavigateToComplete = () => {
    history.push(Object.assign({}, history.location, {
      pathname: `/tracks/${trackId}/${TRACK_COMPLETE_URL_FRAGMENT}`
    }));
  };
  const handleRouteChange = useCallback(event => {
    if (isExamAttemptInProgress) {
      const formatedDeadline = examDeadline && I18n.moment(examDeadline).format(DateFormats.LONG_DATE_AND_TIME);
      const message = I18n.text('learningCenter.exams.pageLeaveAlert', {
        examDeadline: formatedDeadline
      });
      if (event) {
        event.returnValue = message;
      }
      return message;
    }
    return null;
  }, [examDeadline, isExamAttemptInProgress]);
  const maybeTrackPageViewOnce = useCallback(() => {
    if (!pageViewTracked && exam) {
      UsageTracker.track('subpageView', {
        screen: SCREENS.TRACK,
        subscreen: SUB_SCREENS.EXAM,
        examId: exam.id,
        trackId,
        trackName: name,
        hsSoftwareFilters: hsSoftwareFilters.join(', '),
        allCategories: subCategories.join(', ')
      });
      setPageViewTracked(true);
    }
  }, [pageViewTracked, exam, trackId, name, hsSoftwareFilters, subCategories]);
  useEffect(() => {
    window.addEventListener('beforeunload', handleRouteChange);
    maybeTrackPageViewOnce();
    return () => {
      window.removeEventListener('beforeunload', handleRouteChange);
    };
  }, [handleRouteChange, maybeTrackPageViewOnce]);
  useEffect(() => {
    maybeTrackPageViewOnce();
  }, [maybeTrackPageViewOnce]);
  const pageLeaveWarning = handleRouteChange();
  if (!exam) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: `${TRACKS_URL_FRAGMENT}/${trackId}`
    });
  }
  const isDeprecated = isTrackDeprecated(deprecated, deprecationFinalDate);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Prompt, {
      message: pageLeaveWarning || '',
      when: !!pageLeaveWarning
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_EXAM_VIEW_LOADED"
    }), /*#__PURE__*/_jsx(TrackExamPage, {
      onAdvanceContent: handleNavigateToComplete,
      track: track,
      trackProgress: trackProgress
    }), isDeprecated && /*#__PURE__*/_jsx(TrackDeprecatedModal, {
      cta: deprecationCta,
      message: deprecationMessage,
      trackId: trackId
    })]
  });
};
export default TrackExamPageContainer;